import { request } from '@umijs/max';

// dms下载图片
export async function downloadFileService(params: any) {
  return request(`/bcare/file/dms/downloadFile`, {
    responseType: 'blob',
    params,
  });
}

export async function uploadService() {
  return request(`/bcare/file/dms/downloadFile`);
}

// 查询list信息
export async function getMySupportListService(params: any) {
  return request(`/bcare/support/list`, {
    params,
  }).then((res) => res?.supportList || []);
}

// 配置操作
export async function getMySupportOperationService(atcion: string, data: any) {
  return request(`/bcare/support/operation?action=${atcion}`, {
    method: 'POST',
    data,
  });
}
